import { FC } from 'react';

import { useRecoilValue } from 'recoil';

import { showSideMenuAtom } from '@recoil_iqfu/atoms/side_menu/showSideMenu';

import UserButton from '@components_common/user_button/UserButton';
import { UserType } from '@constants_common';

import styles from './DashboardMainArea.module.scss';

type Props = {
  userType: UserType;
  hasRightColumn?: boolean;
  isCompanyMobile?: boolean;
};

const DashboardMainArea: FC<Props> = ({ children, userType, hasRightColumn, isCompanyMobile }) => {
  const showSideMenu = useRecoilValue(showSideMenuAtom);
  return (
    <main
      className={`${styles.container} ${hasRightColumn && styles.hasRightColumn} ${
        isCompanyMobile && styles.isCompanyMobile
      } ${userType === 'admin' && !showSideMenu ? styles.hides_side_menu : ''}`}
      id="dashboard_main_container"
    >
      {!isCompanyMobile && <div className={styles.divider} />}
      <div className={styles.container_inner}>
        <UserButton userType={userType} />
        {children}
      </div>
    </main>
  );
};

export default DashboardMainArea;
